import styled from 'styled-components';

const Row = styled.div`
  padding: 8px 17px;
  border-bottom: 1px solid #e0e0e0;
`;

export default Row;
